import React, { useState, useRef, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { styled, alpha } from "@mui/material/styles";

// Each entry: [emoji, "name keywords"]
const CATEGORIES = [
  {
    label: "😊 Smileys",
    emojis: [
      ["😀","grinning happy smile"],["😃","big smile open mouth"],["😄","smile eyes happy"],
      ["😁","grin beam"],["😆","laughing satisfied"],["😅","sweat smile"],
      ["🤣","rofl rolling laugh floor"],["😂","joy tears laugh cry"],
      ["🙂","slightly smile"],["🙃","upside smile"],["😉","wink"],
      ["😊","smile blush happy"],["😇","innocent halo angel"],["🥰","love heart eyes adore"],
      ["😍","heart eyes love"],["🤩","star eyes wow excited"],["😘","kiss blow"],
      ["😗","kiss"],["😚","kiss closed eyes"],["😙","kiss smile"],
      ["🥲","smile tear"],["😋","yum tongue"],["😛","tongue out"],
      ["😜","winking tongue"],["🤪","zany wild crazy"],["😝","squint tongue"],
      ["🤑","money mouth"],["🤗","hug hugging"],["🤭","hand over mouth giggle"],
      ["🤫","shush quiet silent"],["🤔","thinking hmm"],["🤐","zipper mouth silent"],
      ["🤨","raised eyebrow suspicious"],["😐","neutral expressionless"],["😑","expressionless"],
      ["😶","no mouth silent"],["😏","smirk"],["😒","unamused"],
      ["🙄","roll eyes"],["😬","grimacing"],["🤥","lying nose pinocchio"],
      ["😌","relieved peaceful"],["😔","pensive sad"],["😪","sleepy"],
      ["🤤","drooling"],["😴","sleeping zzz"],["😷","mask sick"],
      ["🤒","sick thermometer ill"],["🤕","bandage hurt injured"],["🤢","nauseated green sick"],
      ["🤧","sneezing cold"],["🥵","hot overheated"],["🥶","cold freezing"],
      ["🥴","woozy dizzy"],["😵","dizzy dead eyes"],["🤯","exploding mind blown"],
      ["🤠","cowboy hat"],["🥳","party celebrate"],["🥸","disguise"],
      ["😎","sunglasses cool"],["🤓","nerd glasses"],["🧐","monocle detective"],
      ["😕","confused"],["😟","worried"],["🙁","frown sad"],
      ["☹️","frown sad"],["😮","open mouth surprised"],["😯","hushed"],
      ["😲","astonished shocked"],["😳","flushed embarrassed"],["🥺","pleading puppy eyes"],
      ["😦","frowning open mouth"],["😧","anguished"],["😨","fearful scared"],
      ["😰","anxious cold sweat"],["😥","sad relieved"],["😢","cry tear"],
      ["😭","sob crying loudly"],["😱","scream fear horror"],["😖","confounded"],
      ["😣","persevering"],["😞","disappointed"],["😓","downcast sweat"],
      ["😩","weary"],["😫","tired"],["🥱","yawning bored"],
      ["😤","triumph steam nose"],["😡","angry rage"],["😠","angry mad"],
      ["🤬","cursing swear"],["😈","devil smiling"],["👿","angry devil"],
      ["💀","skull death dead"],["☠️","skull crossbones"],["💩","poop"],
      ["🤡","clown"],["👹","ogre monster"],["👺","goblin"],
      ["👻","ghost"],["👽","alien"],["👾","space invader"],["🤖","robot"],
    ],
  },
  {
    label: "👋 Gestures",
    emojis: [
      ["👋","wave hello hi"],["🤚","raised back hand"],["🖐","hand splayed"],
      ["✋","raised hand stop"],["🖖","vulcan salute spock"],["👌","ok perfect"],
      ["🤌","pinch italian gesture"],["🤏","small amount"],["✌️","peace victory"],
      ["🤞","crossed fingers luck"],["🤟","love you hand"],["🤘","rock horns metal"],
      ["🤙","call me shaka hang loose"],["👈","point left"],["👉","point right"],
      ["👆","point up"],["👇","point down"],["☝️","index point up"],
      ["👍","thumbs up like agree"],["👎","thumbs down dislike"],["✊","fist bump"],
      ["👊","oncoming fist punch"],["🤛","fist left"],["🤜","fist right"],
      ["👏","clap applause"],["🙌","raised hands celebrate"],["👐","open hands"],
      ["🤲","palms up"],["🤝","handshake deal"],["🙏","pray please thanks folded hands"],
      ["✍️","writing hand"],["💪","muscle strong flex"],["👀","eyes look see"],
      ["👅","tongue"],["👄","lips mouth"],["💋","kiss lips"],
    ],
  },
  {
    label: "❤️ Hearts & Love",
    emojis: [
      ["❤️","red heart love"],["🧡","orange heart"],["💛","yellow heart"],
      ["💚","green heart"],["💙","blue heart"],["💜","purple heart"],
      ["🖤","black heart"],["🤍","white heart"],["🤎","brown heart"],
      ["💔","broken heart"],["❤️‍🔥","heart fire passion"],["❣️","heart exclamation"],
      ["💕","two hearts"],["💞","revolving hearts"],["💓","beating heart"],
      ["💗","growing heart"],["💖","sparkling heart"],["💘","arrow heart"],
      ["💝","heart ribbon gift"],["💌","love letter"],["😻","heart eyes cat"],
      ["🌹","rose flower love"],["💐","bouquet flowers"],["🌷","tulip flower"],
    ],
  },
  {
    label: "🐶 Animals",
    emojis: [
      ["🐶","dog puppy"],["🐱","cat kitten"],["🐭","mouse"],["🐹","hamster"],
      ["🐰","rabbit bunny"],["🦊","fox"],["🐻","bear"],["🐼","panda"],
      ["🐨","koala"],["🐯","tiger"],["🦁","lion"],["🐮","cow"],
      ["🐷","pig"],["🐸","frog"],["🐵","monkey"],["🙈","see no evil monkey"],
      ["🙉","hear no evil monkey"],["🙊","speak no evil monkey"],["🐔","chicken"],
      ["🐧","penguin"],["🐦","bird"],["🐤","chick baby"],["🦆","duck"],
      ["🦅","eagle"],["🦉","owl"],["🦇","bat"],["🐺","wolf"],
      ["🐴","horse"],["🦄","unicorn"],["🐝","bee"],["🦋","butterfly"],
      ["🐌","snail"],["🐞","ladybug"],["🐢","turtle"],["🐍","snake"],
      ["🦎","lizard"],["🐙","octopus"],["🐬","dolphin"],["🐳","whale"],
      ["🦈","shark"],["🐊","crocodile"],["🦒","giraffe"],["🐘","elephant"],
      ["🦛","hippo"],["🦏","rhino"],["🦓","zebra"],["🐕","dog"],
      ["🐈","cat"],["🦜","parrot"],["🦢","swan"],["🐇","rabbit"],
    ],
  },
  {
    label: "🍔 Food & Drink",
    emojis: [
      ["🍎","apple red"],["🍊","orange tangerine"],["🍋","lemon"],["🍌","banana"],
      ["🍉","watermelon"],["🍇","grapes"],["🍓","strawberry"],["🫐","blueberry"],
      ["🍒","cherry"],["🍑","peach"],["🥭","mango"],["🍍","pineapple"],
      ["🥥","coconut"],["🥝","kiwi"],["🍅","tomato"],["🥑","avocado"],
      ["🌶","pepper hot spicy"],["🧄","garlic"],["🧅","onion"],["🍠","sweet potato"],
      ["🥐","croissant"],["🍞","bread"],["🧀","cheese"],["🥚","egg"],
      ["🍳","frying pan egg"],["🥞","pancakes"],["🧇","waffle"],["🥓","bacon"],
      ["🍗","chicken leg poultry"],["🍖","meat bone"],["🌭","hot dog"],
      ["🍔","hamburger burger"],["🍟","fries"],["🍕","pizza"],["🥪","sandwich"],
      ["🌮","taco"],["🌯","burrito wrap"],["🥗","salad green"],["🍝","pasta spaghetti"],
      ["🍜","noodles ramen"],["🍲","pot stew"],["🍛","curry rice"],["🍣","sushi"],
      ["🍱","bento box"],["🥟","dumpling"],["🍤","shrimp fried"],["🍙","rice ball"],
      ["🍚","rice"],["🧁","cupcake"],["🍰","cake slice"],["🎂","birthday cake"],
      ["🍮","custard pudding"],["🍭","lollipop candy"],["🍬","candy"],["🍫","chocolate"],
      ["🍿","popcorn"],["🍩","donut"],["🍪","cookie"],["🌰","chestnut"],
      ["🍯","honey jar"],["🧃","juice box"],["🥤","cup straw"],["🧋","bubble tea boba"],
      ["🍵","tea cup"],["☕","coffee"],["🍺","beer mug"],["🍻","beers cheers"],
      ["🥂","champagne cheers"],["🍷","wine"],["🍸","cocktail martini"],["🍹","tropical drink"],
    ],
  },
  {
    label: "⚽ Activities",
    emojis: [
      ["⚽","soccer football"],["🏀","basketball"],["🏈","american football"],
      ["⚾","baseball"],["🎾","tennis"],["🏐","volleyball"],["🏉","rugby"],
      ["🎱","billiards pool 8 ball"],["🏓","ping pong table tennis"],["🏸","badminton"],
      ["🥊","boxing glove"],["🥋","martial arts"],["⛳","golf"],
      ["🎣","fishing"],["🤿","diving snorkel"],["🛹","skateboard"],["⛸","ice skate"],
      ["🎿","ski"],["🏋️","weightlifting gym"],["🤸","gymnastics cartwheel"],
      ["⛹️","basketball player"],["🏄","surfing"],["🏊","swimming"],["🚴","cycling bicycle"],
      ["🏆","trophy winner"],["🥇","gold medal first"],["🥈","silver medal second"],
      ["🥉","bronze medal third"],["🏅","medal sports"],["🎖","medal decoration"],
      ["🎯","dart target bullseye"],["🎳","bowling"],["🎮","video game controller"],
      ["🎰","slot machine"],["🧩","puzzle jigsaw"],["🎲","dice game"],["♟","chess"],
      ["🎭","theater arts performance"],["🎨","art palette painting"],["🎬","clapperboard film movie"],
      ["🎤","microphone singing"],["🎧","headphones music"],["🎼","musical score"],
      ["🎹","piano keyboard"],["🥁","drums"],["🎷","saxophone"],["🎺","trumpet"],
      ["🎸","guitar"],["🎻","violin"],["🎵","musical note"],["🎶","notes music"],
    ],
  },
  {
    label: "🚗 Travel",
    emojis: [
      ["🚗","car vehicle"],["🚕","taxi cab"],["🚙","suv car"],["🚌","bus"],
      ["🏎","racing car fast"],["🚓","police car"],["🚑","ambulance"],["🚒","fire truck"],
      ["🚐","minibus"],["🚲","bicycle bike"],["🛴","scooter kick"],["🛵","motor scooter"],
      ["🏍","motorcycle"],["🚀","rocket space"],["🛸","ufo flying saucer"],
      ["✈️","airplane plane flight"],["🛩","small plane"],["🚁","helicopter"],
      ["⛵","sailboat"],["🛥","speedboat"],["🚢","ship cruise"],["⛴","ferry"],
      ["🏔","mountain snow"],["⛰","mountain"],["🌋","volcano"],["🏕","camping tent"],
      ["🏖","beach ocean"],["🏜","desert"],["🏝","island"],["🏞","park nature"],
      ["🏛","classical building"],["🏠","house home"],["🏡","house garden"],
      ["🏢","office building"],["🏥","hospital"],["🏦","bank"],
      ["🏨","hotel"],["🏪","store shop"],["🏫","school"],["🏬","department store"],
      ["🕌","mosque"],["⛪","church"],["🕍","synagogue"],["🛕","hindu temple"],
      ["🌍","earth globe europe africa"],["🌎","earth globe americas"],["🌐","globe world"],
    ],
  },
  {
    label: "💡 Objects",
    emojis: [
      ["📱","phone mobile smartphone"],["💻","laptop computer"],["⌨️","keyboard"],
      ["🖥","desktop monitor screen"],["🖨","printer"],["🖱","mouse computer"],
      ["💾","floppy disk save"],["💿","cd disc"],["📀","dvd disc"],
      ["📺","tv television"],["📻","radio"],["📡","satellite"],
      ["🔋","battery"],["🔌","plug electric"],["💡","bulb light idea"],
      ["🔦","flashlight torch"],["🕯","candle"],["💰","money bag"],
      ["💵","dollar bill money"],["💳","credit card"],["📈","chart up graph"],
      ["📉","chart down graph"],["📊","bar chart"],["📋","clipboard"],
      ["📌","pushpin"],["📍","round pushpin location"],["✂️","scissors"],
      ["🖊","pen"],["✏️","pencil"],["📝","memo note"],["💼","briefcase work"],
      ["📁","folder"],["📂","open folder"],["📅","calendar date"],["📆","calendar"],
      ["🔒","locked padlock"],["🔓","unlocked"],["🔑","key"],["🗝","old key"],
      ["🔨","hammer"],["⚙️","gear settings"],["🔧","wrench tool"],["🔩","nut bolt"],
      ["⚖️","scales justice"],["🔗","link chain"],["💊","pill medicine"],
      ["💉","syringe injection"],["🔬","microscope science"],["🔭","telescope"],
      ["🎁","gift present wrapped"],["🎀","ribbon bow"],["🎗","reminder ribbon"],
      ["🛒","shopping cart"],["💎","gem diamond"],["👑","crown king queen"],
      ["👒","hat sun"],["🎩","top hat"],["🧢","cap baseball hat"],
      ["👗","dress"],["👔","necktie shirt"],["👕","shirt tshirt"],
      ["👖","jeans"],["👟","sneakers shoes"],["👠","heels shoes"],
      ["💄","lipstick makeup"],["🕶","sunglasses cool"],["💍","ring diamond"],
      ["🌂","umbrella rain"],["🧲","magnet"],["🎭","theater performance"],
    ],
  },
  {
    label: "⭐ Symbols",
    emojis: [
      ["✅","check mark yes done"],["❌","cross x no wrong"],["⚠️","warning caution"],
      ["🚫","prohibited no ban"],["☑️","checkbox tick"],["❗","exclamation red"],
      ["❓","question mark"],["‼️","double exclamation"],["⁉️","exclamation question"],
      ["💯","hundred percent perfect"],["🔝","top"],["🆕","new"],
      ["🆘","sos help emergency"],["🔴","red circle"],["🟠","orange circle"],
      ["🟡","yellow circle"],["🟢","green circle"],["🔵","blue circle"],["🟣","purple circle"],
      ["⚫","black circle"],["⚪","white circle"],["🔥","fire hot flame"],
      ["💥","explosion boom"],["✨","sparkles glitter"],["🌟","glowing star"],
      ["⭐","star"],["🌈","rainbow"],["⚡","lightning bolt"],["❄️","snowflake cold"],
      ["🌊","wave ocean water"],["🌀","cyclone spiral"],["🌙","moon night crescent"],
      ["☀️","sun sunny"],["⛅","partly cloudy"],["☔","umbrella rain"],
      ["🎉","party popper celebrate"],["🎊","confetti celebrate"],["🎈","balloon party"],
      ["🏆","trophy award winner"],["🔔","bell notification"],["🔕","bell off silent mute"],
      ["📢","loudspeaker announce"],["📣","megaphone cheer"],["♻️","recycle green"],
      ["💤","zzz sleep"],["💢","anger red"],["💨","dash wind"],["💦","sweat droplets water"],
    ],
  },
];

const Popup = styled("div")(({ theme }) => ({
  position: "fixed",
  width: 310,
  maxHeight: 360,
  overflowY: "auto",
  background: theme.palette.mode === "dark" ? "#1e1e26" : "#ffffff",
  border: `1px solid ${alpha(theme.palette.divider, 0.25)}`,
  borderRadius: 12,
  boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
  zIndex: 99999,
  display: "flex",
  flexDirection: "column",
  "&::-webkit-scrollbar": { width: 4 },
  "&::-webkit-scrollbar-thumb": { background: "rgba(128,128,128,0.3)", borderRadius: 4 },
}));

const SearchWrap = styled("div")(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: theme.palette.mode === "dark" ? "#1e1e26" : "#ffffff",
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
  padding: "8px",
}));

const SearchInput = styled("input")(({ theme }) => ({
  width: "100%",
  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
  borderRadius: 8,
  background: theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
  padding: "7px 10px",
  fontSize: 13,
  color: theme.palette.text.primary,
  outline: "none",
  boxSizing: "border-box",
  "&::placeholder": { opacity: 0.45 },
}));

const CategoryLabel = styled("div")(({ theme }) => ({
  padding: "6px 10px 2px",
  fontSize: 11,
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  userSelect: "none",
}));

const Grid = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  padding: "2px 6px 6px",
});

const EmojiBtn = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: 22,
  width: 36,
  height: 36,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 6,
  lineHeight: 1,
  padding: 0,
  "&:hover": { background: alpha(theme.palette.primary.main, 0.12) },
}));

export default function EmojiPicker({ onSelect, anchorRef }) {
  const [search, setSearch] = useState("");
  const popupRef = useRef(null);
  const searchRef = useRef(null);
  const [pos, setPos] = useState({ bottom: 70, right: 16 });

  // Position above the anchor button using fixed coordinates
  useEffect(() => {
    const btn = anchorRef?.current;
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    setPos({
      bottom: window.innerHeight - rect.top + 8,
      right: Math.max(8, window.innerWidth - rect.right),
    });
    // Focus search on open
    setTimeout(() => searchRef.current?.focus(), 50);
  }, [anchorRef]);

  // Close on outside click using 'click' (not 'mousedown') so that clicking
  // outside elements like the Send button still fire their own click handlers first.
  useEffect(() => {
    const handler = (e) => {
      if (
        popupRef.current && !popupRef.current.contains(e.target) &&
        anchorRef?.current && !anchorRef.current.contains(e.target)
      ) {
        onSelect(null);
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [onSelect, anchorRef]);

  // Build flat searchable list
  const allEmojis = useMemo(() => CATEGORIES.flatMap(c => c.emojis), []);

  const q = search.trim().toLowerCase();
  const results = q
    ? allEmojis.filter(([, names]) => names.toLowerCase().includes(q))
    : null;

  const picker = (
    <Popup ref={popupRef} style={{ bottom: pos.bottom, right: pos.right }}>
      <SearchWrap>
        <SearchInput
          ref={searchRef}
          placeholder="Search emoji… (smile, fire, heart)"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </SearchWrap>

      {results ? (
        <Grid style={{ padding: "8px" }}>
          {results.length === 0
            ? <div style={{ padding: "12px", fontSize: 13, opacity: 0.5, width: "100%" }}>No results</div>
            : results.map(([em], i) => (
              <EmojiBtn key={i} onMouseDown={e => { e.preventDefault(); onSelect(em); }} title={em}>
                {em}
              </EmojiBtn>
            ))
          }
        </Grid>
      ) : (
        CATEGORIES.map(cat => (
          <React.Fragment key={cat.label}>
            <CategoryLabel>{cat.label}</CategoryLabel>
            <Grid>
              {cat.emojis.map(([em, names], i) => (
                <EmojiBtn key={i} onMouseDown={e => { e.preventDefault(); onSelect(em); }} title={names.split(" ")[0]}>
                  {em}
                </EmojiBtn>
              ))}
            </Grid>
          </React.Fragment>
        ))
      )}
    </Popup>
  );

  return ReactDOM.createPortal(picker, document.body);
}
